import React, { useContext, useEffect, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, SimpleGrid, Select, HStack, CloseButton, Button, useSelectContext, createListCollection, Field, Input, IconButton } from "@chakra-ui/react";
import { filterEntitiesByProperty, getGeojsonPropertiesKey, resetEntityFilter } from "../../../../../utilies/Utility";
import { LuPlus, LuX } from "react-icons/lu";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
export const LayersFilterDialog = () => {
  // state
  const filterDialog = useAppStore((s) => s.filterDialog);
  const currentLayer = useAppStore((s) => s.currentLayer);
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  // setters / refs
  const setFilterDialog = useAppStore.getState().setFilterDialog;
  const setCurrentLayer = useAppStore.getState().setCurrentLayer;

  const viewerRef = useAppStore.getState().viewerRef;

  const [labelPropertiesOption, setLabelPropertiesOption] = useState([]);

  const operationOption = [{ name: "==" }, { name: "!=" }, { name: "<" }, { name: "<=" }, { name: ">" }, { name: ">=" }];
  const key1Option = [{ name: "relation" }, { name: "way" }, { name: "node" }];

  const [filters, setFilters] = useState([{ key2: "", key1: "", operation: "==", value: "" }]);

  useEffect(() => {
    if (filterDialog && currentLayer.view_type === "lanelet") {
      const previewLabel = getGeojsonPropertiesKey(currentLayer.geojson);
      const temp = Object.values(previewLabel).map((name) => ({ name }));
      setLabelPropertiesOption(temp);

      if (Array.isArray(currentLayer.filters)) {
        setFilters(currentLayer.filters);
      } else {
        setFilters([{ key2: "", key1: "", operation: "==", value: "" }]);
      }
    }
  }, [currentLayer, filterDialog]);

  const updateFilter = (index, field, newValue) => {
    const updated = [...filters];
    updated[index][field] = newValue;
    setFilters(updated);
  };

  const addFilter = () => {
    setFilters([...filters, { key2: "", key1: "", operation: "==", value: "" }]);
  };

  const removeFilter = (index) => {
    const updated = filters.filter((_, i) => i !== index);
    setFilters(updated.length > 0 ? updated : [{ key2: "", key1: "", operation: "==", value: "" }]);
  };

  const handleFilter = () => {
    filterEntitiesByProperty(viewerRef.current, currentLayer.osmDataSource, filters);
    const updatedMap = [...mapObjects];
    for (const key in updatedMap) {
      if (updatedMap[key].id == currentLayer.id) {
        updatedMap[key].filters = filters;
        break;
      }
    }
    setMapObjects(updatedMap);

    setFilterDialog(false);
  };

  const handleRemove = () => {
    resetEntityFilter(currentLayer.osmDataSource);

    const updatedMap = [...mapObjects];
    for (const key in updatedMap) {
      if (updatedMap[key].id == currentLayer.id) {
        updatedMap[key].filters = undefined;
        break;
      }
    }
    setMapObjects(updatedMap);

    setFilterDialog(false);
  };

  const key1Collection = React.useMemo(
    () =>
      createListCollection({
        items: key1Option,
        itemToString: (item) => item.name,
        itemToValue: (item) => item.name,
      }),
    [key1Option]
  );

  const key2Collection = React.useMemo(
    () =>
      createListCollection({
        items: labelPropertiesOption,
        itemToString: (item) => item.name,
        itemToValue: (item) => item.name,
      }),
    [labelPropertiesOption]
  );

  const operationCollection = React.useMemo(
    () =>
      createListCollection({
        items: operationOption,
        itemToString: (item) => item.name,
        itemToValue: (item) => item.name,
      }),
    [operationOption]
  );

  return (
    <Dialog.Root
      lazyMount
      open={filterDialog}
      onOpenChange={(e) => {
        setFilterDialog(e.open);
        if (!Boolean(e.open)) {
          setCurrentLayer(null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Filter</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              {filters.map((filter, index) => (
                <SimpleGrid columns={5} gap={2} key={index} alignItems="end">
                  {/* First Key */}
                  <Select.Root collection={key1Collection} size="sm" value={[filter.key1]} positioning={{ sameWidth: true }} onValueChange={(value) => updateFilter(index, "key1", value.value[0])}>
                    <Select.HiddenSelect />
                    <Select.Control>
                      <Select.Trigger>
                        <HStack>{filter.key1 || "Key 1"}</HStack>
                      </Select.Trigger>
                      <Select.IndicatorGroup>
                        <Select.Indicator />
                      </Select.IndicatorGroup>
                    </Select.Control>
                    <Select.Positioner>
                      <Select.Content>
                        {key1Option.map((item) => (
                          <Select.Item key={item.name} item={item}>
                            {item.name}
                            <Select.ItemIndicator />
                          </Select.Item>
                        ))}
                      </Select.Content>
                    </Select.Positioner>
                  </Select.Root>

                  {/* Second Key */}
                  <Select.Root collection={key2Collection} size="sm" value={[filter.key2]} positioning={{ sameWidth: true }} onValueChange={(value) => updateFilter(index, "key2", value.value[0])}>
                    <Select.HiddenSelect />
                    <Select.Control>
                      <Select.Trigger>
                        <HStack>{filter.key2 || "Key 2"}</HStack>
                      </Select.Trigger>
                      <Select.IndicatorGroup>
                        <Select.Indicator />
                      </Select.IndicatorGroup>
                    </Select.Control>
                    <Select.Positioner>
                      <Select.Content>
                        {labelPropertiesOption.map((item) => (
                          <Select.Item key={item.name} item={item}>
                            {item.name}
                            <Select.ItemIndicator />
                          </Select.Item>
                        ))}
                      </Select.Content>
                    </Select.Positioner>
                  </Select.Root>

                  {/* Operation */}
                  <Select.Root
                    collection={operationCollection}
                    size="sm"
                    value={[filter.operation]}
                    positioning={{ sameWidth: true }}
                    onValueChange={(value) => updateFilter(index, "operation", value.value[0])}
                  >
                    <Select.HiddenSelect />
                    <Select.Control>
                      <Select.Trigger>
                        <HStack>{filter.operation}</HStack>
                      </Select.Trigger>
                      <Select.IndicatorGroup>
                        <Select.Indicator />
                      </Select.IndicatorGroup>
                    </Select.Control>
                    <Select.Positioner>
                      <Select.Content>
                        {operationOption.map((item) => (
                          <Select.Item key={item.name} item={item}>
                            {item.name}
                            <Select.ItemIndicator />
                          </Select.Item>
                        ))}
                      </Select.Content>
                    </Select.Positioner>
                  </Select.Root>

                  {/* Value */}
                  <Field.Root>
                    <Input height={"36px"} placeholder="Value" value={filter.value} onChange={(e) => updateFilter(index, "value", e.target.value)} />
                  </Field.Root>

                  {/* Remove */}
                  <Button size="sm" variant="ghost" mt={4} onClick={() => removeFilter(index)}>
                    <LuX />
                  </Button>
                </SimpleGrid>
              ))}

              {/* Add Filter Button */}
              <Button size="sm" variant="ghost" mt={4} leftIcon={<LuPlus />} onClick={addFilter}>
                Add Condition
              </Button>
            </Dialog.Body>

            <Dialog.Footer>
              <Button onClick={handleRemove}>Remove Filters</Button>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button onClick={handleFilter}>Filter</Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersFilterDialog;
